const NEWS_FIELDS = Object.freeze([
  { identifier: 'displayImage', label: s__('Builder|image') },
  { identifier: 'displayTitle', label: s__('Builder|title') },
  { identifier: 'displayDate', label: s__('Builder|date') },
  { identifier: 'displayTags', label: s__('Builder|category tags') },
  { identifier: 'displayTextLink', label: s__('Builder|text link') },
  { identifier: 'displayDescription', label: s__('Builder|description') },
]);

const EVENTS_FIELDS = Object.freeze([
  { identifier: 'displayImage', label: s__('Builder|image') },
  { identifier: 'displayTitle', label: s__('Builder|title') },
  { identifier: 'displayDate', label: s__('Builder|date') },
  { identifier: 'displayTags', label: s__('Builder|category tags') },
  { identifier: 'displayLocation', label: s__('Builder|location') },
  { identifier: 'displayAttendees', label: s__('Builder|attendees') },
  { identifier: 'displayOnlineEvent', label: s__('Builder|online event') },
]);

export const FIELD_SETTING_OBJECTS = Object.freeze({
  events: EVENTS_FIELDS,
  news: NEWS_FIELDS,
});

export const FIELD_SETTING_PATH = 'attributes.dynamicAttributes.fields';
